import { SecurityShareValue, SecurityShareValueProps } from './types';

const normalizeShareValues = ({ share_values }: SecurityShareValueProps) =>
  share_values.map((sv: SecurityShareValue) => ({
    ...sv,
    value: Number(sv.share_price),
  }));

export default normalizeShareValues;
